function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import ContactSalesHubspotFormComponent from "./components/contact-sales-hubspot-form-component";
import { StyledSideBySideHubspotFormComponent } from "./side-by-side-hubspot-form-component.scss";
const AssetWithParagraph = ({ fullParagraph, asset, gap })=>/*#__PURE__*/ _jsxs("div", {
        className: "side-by-side-asset-and-paragraph",
        style: {
            gap
        },
        children: [
            fullParagraph && /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph)),
            /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset))
        ]
    });
class SideBySideHubspotFormComponent extends PureComponent {
    render() {
        const _this_props = this.props, { formId, withPrivacyNotice, useNewBaseForm, dontRenderPostFormSubmit, formMinHeight, asset, fullParagraph, assetAndParagraphGap, alignToLogo, urlToRedirectAfterSubmission, maxWidth } = _this_props, restProps = _object_without_properties(_this_props, [
            "formId",
            "withPrivacyNotice",
            "useNewBaseForm",
            "dontRenderPostFormSubmit",
            "formMinHeight",
            "asset",
            "fullParagraph",
            "assetAndParagraphGap",
            "alignToLogo",
            "urlToRedirectAfterSubmission",
            "maxWidth"
        ]);
        const replaceTextComponentProps = {
            formId,
            withPrivacyNotice,
            useNewBaseForm,
            dontRenderPostFormSubmit,
            formMinHeight,
            urlToRedirectAfterSubmission
        };
        const replaceAssetComponentProps = {
            asset,
            fullParagraph,
            gap: assetAndParagraphGap
        };
        return /*#__PURE__*/ _jsx(StyledSideBySideHubspotFormComponent, {
            maxWidth: maxWidth,
            className: "side-by-side-hubspot-form-component",
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
                replaceTextComponent: ContactSalesHubspotFormComponent,
                replaceTextComponentProps: replaceTextComponentProps,
                replaceAssetComponent: AssetWithParagraph,
                replaceAssetComponentProps: replaceAssetComponentProps,
                asset: asset,
                alignToLogo: alignToLogo
            }, restProps))
        });
    }
}
export { SideBySideHubspotFormComponent as default };
SideBySideHubspotFormComponent.defaultProps = {
    width: "100%",
    maxWidth: 1440,
    formId: "706f2f71-b48f-4dde-850f-055f5e3664d2",
    asset: {
        fitToContainer: true,
        image: {
            src: "/static/img/segment-layout-default-images/sales_social.png"
        }
    }
};
